import React, { useEffect, useState } from 'react';
import TableHeader from '../TableParts/TableHeader';
import TableFooter from '../TableParts/TableFooter';
import TableBody from '../TableParts/TableBody';
import { cartCartSelector, cartMainProduct } from '../../redux/selectors/cartSelector';
import { connect } from 'react-redux';
import { includeExtra, includeProduct } from '../../redux/actions/cartAction';
import TableDiscount from '../TableParts/TableDiscount';
import { useFilters } from '../../hooks/useFilters';
import cn from 'classnames';
import useTotal from '../../hooks/useTotal';
import useTotalDiscount from '../../hooks/useTotalDiscount';
import isPeriodDifferentByProducts from '../../resolvers/isPeriodDifferentByProducts';
import getDiscountDaysByProduct from '../../resolvers/getDiscountDaysByProduct';
import {productCurrentProductIdSelector, productProductsSelector} from '../../redux/selectors/productSelector';
import { showWarning } from '../../lib/toast';
import isProductInclusionAllowed from '../../resolvers/isProductInclusionAllowed';
import {pagesTariffsByProductSelector} from "../../redux/selectors/pagesSelectors";

function FeaturedProductItem({ product, id, cart, includeProduct, mainProduct, includeExtra, products, tariffListByProduct, productCurrentProductId}) {
    const [checked, setChecked] = useState(product?.isIncluded || false);
    const [isAvailableFeaturedOption, setIsAvailableFeaturedOption] = useState(false);
    const productTotal = useTotal(product?.product_id);
    const productDiscount = useTotalDiscount(product?.product_id);
    const warningInclusionMessages = `Featured product "${product.product_name}" is not available for selected Period or Package. Please check the package limits.`;

    useFilters(product, product?.product_id);

    const [services, setServices] = useState(0);

    useEffect(() => {
        if (mainProduct?.current_tariff_id && tariffListByProduct[mainProduct?.current_tariff_id] && tariffListByProduct[mainProduct?.current_tariff_id].services) {
            setServices(tariffListByProduct[mainProduct?.current_tariff_id].services);
        }
    }, [mainProduct, tariffListByProduct])

    useEffect(() => {
        const flag = isProductInclusionAllowed(product, mainProduct, cart);
        setIsAvailableFeaturedOption(flag);
        if (product?.isIncluded && !flag) {
            handleProductInclusion(false, true);
        }
    }, [product, products, mainProduct]);

    useEffect(() => {
        setChecked(!!product?.tariff && product?.isIncluded);
    }, [mainProduct?.tariff, product?.tariff, product?.isIncluded])

    const handleProductInclusion = (value, transitiveUpdate) => {
        const flag = isProductInclusionAllowed(product, mainProduct, cart);
        if (value && !flag && !transitiveUpdate) {
            showWarning('auto-switch-off-featured-product', warningInclusionMessages);
        }

        setIsAvailableFeaturedOption(flag);
        if (value && flag) {
            includeProduct(
                { value: true, product_id: product?.product_id, change: true },
                () => setChecked(flag)
            );
        } else {
            includeProduct(
                { value: false, product_id: product?.product_id, change: true },
                () => setChecked(flag)
            );
        }
    }

    return (
        <div hidden={productTotal > 1}
            className={cn('section__container flex flex--center mb-28 featured', {
                active: product?.isIncluded && isAvailableFeaturedOption,
                'not-available': !isAvailableFeaturedOption
            })}
        >
            <div className="checkbox">
                <input
                    type="checkbox"
                    id={id}
                    className="checkbox__input"
                    checked={checked && isAvailableFeaturedOption}
                    onChange={(e) => handleProductInclusion(e.target.checked) }
                />
                <label htmlFor={id} className="checkbox__label">
                    <span className={'hidden'}>text</span>
                </label>
            </div>
            <section
                className={`section--table section--featured section--table--${cart?.currency?.currency?.toLowerCase()}`}
            >
                <TableHeader />
                <TableBody
                    product={product}
                    product_id={product?.product_id}
                    currency={cart?.currency}
                    includeExtra={includeExtra}
                />
                {!!getDiscountDaysByProduct(product) && (
                    <TableDiscount
                        product_id={product?.product_id}
                        product={product}
                        currency={cart?.currency}
                        services={services}
                        productCurrentProductId={productCurrentProductId}
                    />
                )}
                 {/*Products with different periods are not allowed for purchase*/}
                {isPeriodDifferentByProducts(mainProduct, product) && (
                    <TableFooter product={product}
                                 total={'-'}
                                 discount={'-'} />
                ) || (
                    <TableFooter product={product}
                                 total={productTotal}
                                 discount={productDiscount} />
                )}
            </section>
        </div>
    );
}

const mapStateToProps = (state) => ({
    cart: cartCartSelector(state),
    mainProduct: cartMainProduct(state),
    products: productProductsSelector(state),
    tariffListByProduct: pagesTariffsByProductSelector(state),
    productCurrentProductId: productCurrentProductIdSelector(state),

});

const mapDispatchToProps = (dispatch) => ({
    includeProduct: (value) => dispatch(includeProduct(value)),
    includeExtra: (value) => dispatch(includeExtra(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedProductItem);
